module.exports = __webpack_public_path__ + "static/media/Thonburi_Bold.8e3ff232.svg";